import React from "react";

import { Link, useLocation } from "@reach/router";
import { Grid, Typography } from "@material-ui/core";
import MaskedInput from "react-text-mask";
import { omit } from "lodash";
import { US_PHONE_MASK } from "utils/phone";
import { PasswordValidationType } from "components/login/utils";
import { useRedirectPropertiesPageFeature } from "components/feature/use-redirect-properties-page-feature";
import Settings from "settings";
import { loginStyles } from "./styles";

export const LoneGrid: React.FC<{ children?: React.ReactNode; blue?: boolean; }> = (props) => (
  <div style={{ margin: "8px" }}>
    <Grid container spacing={2} direction="column" alignItems="center" justifyContent="center" item style={props.blue ? { backgroundColor: "#32445A" } : {}} >
      {props.children}
    </Grid>
  </div>
);

export const BackToLogin: React.FC = () => {
  const location = useLocation();
  return (
    <LoneGrid>
      <Typography style={loginStyles.bottomLink}>
      Back to <Link to={`/login${location.search}`}>Log In</Link>
      </Typography>
    </LoneGrid>
  );
};

export const SignUpLink: React.FC = () => {
  const redirectPropertiesPage = useRedirectPropertiesPageFeature();

  return (
    <LoneGrid>
      <Typography style={loginStyles.bottomLink} >
      Don&apos;t have an account yet? &nbsp;
        {redirectPropertiesPage ? (
          <Link to="../properties">Find Housing</Link>
        ) : (
          <a href={`${Settings.whitelabel_server_url}/properties`}>Find Housing</a>
        )}
      </Typography>
    </LoneGrid>
  );
};


export const HavenConnectLoginLogo: React.FC<{ dark?: boolean }> = (props) => (
  <LoneGrid>
    <Link to="/">
      <div style={props.dark ? loginStyles.logoLoginDark : loginStyles.logoLogin} />
    </Link>
  </LoneGrid>
);

type LoginCardTitleProps = { title: string | React.ReactNode }
export const LoginCardTitle: React.FC<LoginCardTitleProps> = (props) => (
  <Typography align="center" variant="h2" style={loginStyles.titleMessage}>
    {props.title}
  </Typography>
);

export const LoginCardSubtitle: React.FC = (props) => (
  <Typography align="center" style={loginStyles.instructionsMessage}>
    {props.children}
  </Typography>
);


export const TextMaskCustom: React.FC = (props) => {
  const other = omit(props, ["inputRef"]);

  return (
    <MaskedInput
      {...other}
      mask={US_PHONE_MASK}
      placeholderChar={"\u2000"}
    />
  );
};


export const PasswordValidations: React.FC<{errors: PasswordValidationType[]}> = ({ errors }) => (
  <ul style={{ fontSize: 12, paddingLeft: 12 }}>
    {errors
      .filter(({ field }) => field === "password")
      .map((error, idx) => <li key={idx}>{error.shortMessage}</li>)}
  </ul>);
